import { Button, FlexBox, Text } from '@dixa/lib-shared-habla';

import DixaElevio from 'images/dixa-and-elevio.png';

import styles from './styles.module.scss';

export function Upgrade(): JSX.Element {
  return (
    <div className={styles.card}>
      <img className={styles.heroImg} src={DixaElevio} />

      <Text.Paragraph subdued>
        Reach out to our support team to setup access.
      </Text.Paragraph>

      <FlexBox>
        <Button
          variant="primary"
          className={styles.loginButton}
          onClick={() => window.open('https://www.dixa.com/contact/', '_blank')}
        >
          Contact us
        </Button>
      </FlexBox>
    </div>
  );
}
